import React from 'react'
import Notification from '../../features/student/Notification'

const NotificationPage = () => {
  return <Notification/>
}

export default NotificationPage